import React from 'react'
import {Table } from 'semantic-ui-react'
import { Divider} from 'antd';
import {

    BellOutlined  ,
  
  } from '@ant-design/icons';
  
export default function SeatingPlan() {
    return (
        <div>
              <Divider
            orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <BellOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </BellOutlined> &nbsp;&nbsp;Seating Plan</Divider>
         <Table color="blue" >
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Date</Table.HeaderCell>
            <Table.HeaderCell>subject</Table.HeaderCell>
            <Table.HeaderCell>Timmings</Table.HeaderCell>
            <Table.HeaderCell> Room</Table.HeaderCell>
            <Table.HeaderCell> Type</Table.HeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          <Table.Row>
            <Table.Cell>Apples</Table.Cell>
            <Table.Cell>200</Table.Cell>
            <Table.Cell>0g</Table.Cell>
            <Table.Cell>04g</Table.Cell>
            <Table.Cell>04g</Table.Cell>
          </Table.Row>
        
        </Table.Body>
      </Table>
        </div>
    )
}
